const M = [
  {
    name: "reservationWithdraw",
    zh: "预约提现",
    en: "Reservation withdraw"
  },
  {
    name: "outletsWithdraw",
    zh: "网点提现",
    en: "Partnered Outlet"
  },
  {
    name: "aliPayWithdraw",
    zh: "支付宝提现",
    en: "AliPay withdraw"
  },
  {
    name: "withdrawAmount",
    zh: "提现金额",
    en: "Withdraw amount"
  },
  {
    name: "withdrawAll",
    zh: "全部提现",
    en: "Withdraw all"
  },
  {
    name: "singleWithdrawalLimited",
    zh: "单次提现金额限制",
    en: "The single withdrawal amount is limited "
  },
  {
    name: "monthWithdrawalLimited",
    zh: "本月提现金额剩余",
    en: "The withdraw amount of this month reminds "
  },
  {
    name: "withdrawalAmountGreaterThanMonth",
    zh: "提现金额不能大于本月提现金额",
    en:
      "The cash withdrawal amount cannot be greater than this month's cash withdrawal amount"
  },
  {
    name: "submitForAudit",
    zh: "提交审核",
    en: "Submit"
  },
  {
    name: "amountLimit",
    zh: "金额限制",
    en: "Amount limit"
  },
  {
    name: "serviceHours",
    zh: "服务时间",
    en: "Service available time"
  },
  {
    name: "serviceDesc",
    zh: "服务说明",
    en: "Service description"
  },
  {
    name: "serviceHotline",
    zh: "服务热线",
    en: "Service hotline"
  },
  {
    name: "serviceArea",
    zh: "服务范围",
    en: "Service area"
  },
  {
    name: "dialNumber",
    zh: "拨打号码",
    en: "Call service hotline"
  },
  {
    name: "officialContactInfo",
    zh: "官方联系方式",
    en: "Contact information"
  },
  {
    name: "weChatService",
    zh: "微信公众号客服",
    en: "Customer service of WeChat"
  },
  {
    name: "consultingNumber",
    zh: "咨询电话",
    en: "Branch phone number"
  },
  {
    name: "doorToDoor",
    zh: "小额上门充值/提现服务热线",
    en: "Small amount door-to-door Cash in/ withdraw service hotline"
  },
  {
    name: "mobileNumber",
    zh: "电话",
    en: "Phone number"
  },
  {
    name: "onlineServiceCustomer",
    zh: "在线客服",
    en: "Online customer service"
  },
  {
    name: "eepayOnlineServiceCustomer",
    zh: "易付宝在线客服",
    en: "eepay online customer service"
  }
];

export default M;
